import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            libelle: "",
            // plafond_emission: "",
            // periode: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                libelle: element.libelle,
                // plafond_emission: element.plafond_emission.toLocaleString(),
                // periode: element.periode,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
                //btn: "<router-link to='/theme/typepieces/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setTypePiece(state, typepieces) {
        state.all = typepieces
    },
    addTypePiece(state, typepieces) {
        state.all.push(typepieces)
    }
}

const actions={
    get_all_typepieces({ commit }, serverParams){
        return api.typepiece.get_all_typepieces(serverParams).then((response)=>{
            console.log(response)
            commit('setTypePiece', response.data.data.data)
            return response.data.data
        })
    },
    post_typepiece({commit},typepiece){
        return api.typepiece.post_typepiece(typepiece).then((response)=>{
            commit('addTypePiece', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_typepiece({ commit }, data) {
        //console.log("mes datas ", data)
        return api.typepiece.put_typepiece(data.libelle, data.typepiece).then((response) => {
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    show_typepiece({ commit }, id) {
        return api.typepiece.show_typedepiece(id).then((response) => {
            return response.data.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
